import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { MessageV2DTO } from 'support/types';
import { Translate } from 'components/Translate/Translate';

type ProcurosCopy = {
  title: string | null;
  description: ReactNode;
  howToFix: ReactNode;
};

export const useProcurosErrorCodeCopy = (blockingError: MessageV2DTO['blocking_error'] | undefined): ProcurosCopy => {
  const { t, i18n } = useTranslation();

  let title: string | null = blockingError?.title || null;
  let description: ReactNode = blockingError?.description ? <Translate i18nKey={blockingError.description} /> : null;
  let howToFix: ReactNode = blockingError?.howToFix ? <Translate i18nKey={blockingError.howToFix} /> : null;

  const code = blockingError?.code;
  if (code) {
    const titleKey = `webedi:viewDocument.procurosIsIssueResolver.${code}.title`;
    const descriptionKey = `webedi:viewDocument.procurosIsIssueResolver.${code}.description`;
    const howToFixKey = `webedi:viewDocument.procurosIsIssueResolver.${code}.howToFix`;

    title = i18n.exists(titleKey) ? t(titleKey) : title;
    description = i18n.exists(descriptionKey) ? <span>{t(descriptionKey)}</span> : description;
    howToFix = i18n.exists(howToFixKey) ? t(howToFixKey) : howToFix;
  }

  return { title, description, howToFix };
};

/**
 * i18n keys
 * t('webedi:viewDocument.procurosIsIssueResolver.1724421292.title')
 * t('webedi:viewDocument.procurosIsIssueResolver.1724421292.description')
 * t('webedi:viewDocument.procurosIsIssueResolver.1724421292.howToFix')
 */
